// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.testTitle {
    color: white;
    text-align: center;
}

.infoTextTestContent {
    color: var(--HighlightBlue);
    font-family: monospace;
    opacity: 0.5;
    text-shadow: 1px 1px #558abb;
}

.testSectionContainerConsoleDisplay {
    min-height: 20em;
    max-height: 20em;
    background-color: var(--GrayBlue);
    overflow-y: scroll;
    text-align: left;
    white-space: pre-wrap;
    word-break: break-word;
    box-shadow: inset 0 0 10px var(--DarkBlue);
    padding: 0.3em;
}

.buttonContainerConsoleDisplayTest {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    list-style-type: none;
    margin: 0 auto;
    gap: 0.5em;
}
`, "",{"version":3,"sources":["webpack://./src/components/Admin/Tests/test.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;IAC3B,sBAAsB;IACtB,YAAY;IACZ,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,iCAAiC;IACjC,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,sBAAsB;IACtB,0CAA0C;IAC1C,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,qBAAqB;IACrB,cAAc;IACd,UAAU;AACd","sourcesContent":[".testTitle {\n    color: white;\n    text-align: center;\n}\n\n.infoTextTestContent {\n    color: var(--HighlightBlue);\n    font-family: monospace;\n    opacity: 0.5;\n    text-shadow: 1px 1px #558abb;\n}\n\n.testSectionContainerConsoleDisplay {\n    min-height: 20em;\n    max-height: 20em;\n    background-color: var(--GrayBlue);\n    overflow-y: scroll;\n    text-align: left;\n    white-space: pre-wrap;\n    word-break: break-word;\n    box-shadow: inset 0 0 10px var(--DarkBlue);\n    padding: 0.3em;\n}\n\n.buttonContainerConsoleDisplayTest {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    list-style-type: none;\n    margin: 0 auto;\n    gap: 0.5em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
